<template>
  <body>
  <cursor-fx ref="cursor" color="#6b4000" color-hover="#fa9732" inside-size="15px" outside-size="90px"></cursor-fx>
  <div class="all_box">
    <div class="apply_btn_box">
      <router-link to="ApplicationForm"><btn class="apply_btn" data-cursor-hover>
        応募する
      </btn></router-link>
    </div>
    <div class="cb" />
    <div class="title_box jp_font">
      <div>
        <div class="title_h1 en_font">REQUIREMENTS</div>
        <div class="title_h2 jp_font">募集概要 ー エンジニア職</div>
      </div>
    </div>
    <div />
    <div class="Requirements_Engineer_box ">
      
      <!-- <img class="Requirements_Engineer_img" v-lazy="require('@/assets/bosyu_422A9632_2048px.jpg')" /> -->
      <div class="Requirements_Engineer_smallbox">
        <p class="Requirements_Engineer_subtitle">仕事概要</p>
        <p class="Requirements_Engineer_text">本人の希望や適正を鑑み、以下業務を担当してもらいます。<br/>
                                              基本的にはチームでの業務となり、単独で実施することはありません。<br/>
                                              ネットワーク・サーバーの設計・構築をメインに、 チーム配属で業務に取り組んでいただきます。 
        </p>
        <p class="Requirements_Engineer_text">【ITコンサルティング】<br/>
                                              顧客が抱える様々な要求や課題に対し、高い技術的な知見を活かしてその課題の解決策を提案し、実行していきます。<br/>
                                              顕在化している要求や課題はもちろんのこと、潜在的な要求や課題を解決するため、徹底的な顧客目線でのソリューションの提案を実施します。<br/>
                                              単なるIT利用にとどまらず、顧客にとって最適なデジタル利用環境の推進を行います。
        </p>
        <p class="Requirements_Engineer_text">【クラウドサービス開発】<br/>
                                              Azure、AWS、GCP、Aliyunなどのパブリッククラウドサービスを利用し、サービスの導入支援、設計・開発を実施します。<br/>
                                              顧客業務に応じてオンプレからクラウドへのクラウドリフトの提案や、既存クラウド利用の拡大、クラウドネイティブな環境の推進など様々なニーズに対応したソリューションを提供します。
        </p>
        <p class="Requirements_Engineer_text">【デジタルオペレーション開発】<br/>
                                               チャットボットやRPA、AIを利用し、お客様に最適なデジタルレイバー環境の構築を実施します。<br/>
                                              手動で実施している業務を対話ベースのデジタルオペレーションへ置き換える事で顧客業務の効率化に寄与します。
        </p>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">必須スキル</p>
        <ul class="Requirements_Engineer_text">
          <li>従業員に対し常に前向きで明るい対応ができ、チームメンバー同士協力し合いながら仕事ができること</li>
          <li>ITインフラ系での実務経験</li>
          <span>※設計・構築、運用・保守、監視など担当工程不問（未経験の方も応相談）</span>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">歓迎スキル</p>
        <ul class="Requirements_Engineer_text">
          <li>プロジェクトマネジメント経験</li>
          <li>プロダクト開発経験(プロダクト開発を企画から参画し、設計・コーディングまで担当した方、大歓迎！)</li>
          <li>デジタルオペレーター開発経験</li>
          <li>パブリッククラウド導入・移行経験</li>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">求める人物像</p>
        <ul class="Requirements_Engineer_text">
          <li>役職に関係なくリーダーシップとスキルを発揮し、バリュー(成果、付加価値)を出すことに集中できる方</li>
          <li>論理的な思考を持ち、適切な質疑応答等のコミュニケーションができる方</li>
          <li>情報工学基礎相当の知識のある方</li>
        </ul>
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">応募概要</p>
        
        <table class="Requirements_Engineer_table">
          <tr>
            <th>給与</th>
            <td>500万円  ～  1,200万円</td>
          </tr>
          <tr>
            <th>勤務地</th>
            <td>〒140-0013<br />
                東京都品川区南大井 6-22-7 大森ベルポートE館2階<br />
                <span>※プロジェクトによって変更となる可能性があります</span>    
            </td>
          </tr>
          <tr>
            <th>勤務体系</th>
            <td>■勤務時間<br />
                9:00 ～ 18:00（休憩 12:00 ～13:00）<br />
                <span>※プロジェクトによって変更となる可能性があります</span><br /><br />
                ■年間休日数<br />
                120 日以上
            </td>
          </tr>
          <tr class="Requirements_Engineer_last">
            <th>福利厚生</th>
            <td ><ul>
                  <li>有給休暇は入社翌月から16日付与</li>
                  <li>賞与年２回 （2023 年度実績：平均年6.8ヶ月分）</li>
                  <li>住宅手当:<br>
                      配偶者ありの場合(40歳まで)：家賃の半額(上限6万円)<br>
                      配偶者なしの場合(34歳まで)：家賃の半額(上限3万円)
                  </li>
                  <li>関東ITソフトウェア健康保険組合加入</li>
                  <li>家族手当（扶養家族１人につき月１万円）</li>
                  <li>残業月平均17時間</li>
                  <li>リモートワークや時差出勤あり</li>
                  <li>フレックス制（コアタイムなし）</li>
                  <li>お茶、お水、コーヒーなどを無料で飲めるオフィス内フリードリンク制度あり</li>
                </ul>
            </td>
          </tr>
        </table>
 
        <div style="padding-top:30px;" />
        <p class="Requirements_Engineer_subtitle">企業情報</p>

        <table class="Requirements_Engineer_table">
          <tr>
            <th>企業名</th>
            <td>株式会社HES</td>
          </tr>
          <tr>
            <th>設立年月日</th>
            <td>2019年 （令和元年）7 月 10 日
            </td>
          </tr>
          <tr>
            <th>本社所在地</th>
            <td>〒140-0013<br />
              東京都品川区南大井 6-22-7 大森ベルポートE館2階<br /> 
            </td>
          </tr>
          <tr>
            <th>資本金</th>
            <td>3,000万円
            </td>
          </tr>
          <tr class="Requirements_Engineer_last">
            <th>従業員数</th>
            <td>65 名（2024/4/1時点）<br />
                平均年齢 / 35 歳<br />
                男女比 / 男性 56名、女性 9名<br />
                <!--中途入社の割合 / 100％-->
            </td>
          </tr>
        </table>
        <div style="padding-top:30px;" />
      
      </div>
    </div>
    <div class="Requirements_Engineer_endbox"/>
    <div class="Requirements_Engineer_Application_box">
      <div class="Requirements_Engineer_Application_smallbox">
        <p class="Requirements_Engineer_Application_subtitle">応募について</p>
        <p class="Requirements_Engineer_Application_text">選考プロセスは下記のとおりです。<br />まずはカジュアル面談をしてみて選考に進むか検討したいという方もお気軽にご応募ください。</p>
      
        <div class="mv_none" style="padding-top:30px;" />
        <div class="Requirements_Engineer_Application_flex">
          <div class="Requirements_Engineer_Application_flex_item">
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">01</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                カジュアル面談
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">02</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                書類選考
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">03</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                シニアエンジニア面接
              </span>
            </p>
            <p class="Requirements_Engineer_Application_circle">
              <span>
                <div class="Requirements_Engineer_Application_STEP">STEP</div>
                <div class="Requirements_Engineer_Application_NUM">04</div>
              </span>
              <span class="Requirements_Engineer_Application_step_text">
                代表取締役面接
              </span>
            </p>
          </div>
          <div class="Requirements_Engineer_Application_flex_item">
            <p class="Requirements_Engineer_Application_subbox">◆東京都の奨学金返還支援事業の登録企業です<br/>
              <a class="Requirements_Engineer_item_link" href="https://tokyo-scholarship-support.jp/corpinfo/3611/" target="_blank" rel="noopener noreferrer" data-cursor-hover>・掲載ページはこちら
                <svg class="linkicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="#c04d00" d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>
              </a><br/>
              <a class="Requirements_Engineer_item_link" href="https://tokyo-scholarship-support.jp" target="_blank" rel="noopener noreferrer" data-cursor-hover>・事業内容はこちら
                <svg class="linkicon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path fill="#c04d00" d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>
              </a><br/>
                                                                  ※奨学金返還費用の一部を助成する制度です(学生または既卒3年以内の方が対象となります)詳しくはお問い合わせください<br/><br/>
                                                                
                                                                  ◆Web面接(Zoom)も可能です。お気軽にお問い合わせください<br/>
                                                                  ※応募の秘密厳守します<br/>
                                                                  ※書類選考に1～2週間程度お時間を頂いております<br/>
                                                                  ※応募書類はご返却できませんので、予めご了承ください<br/>
                                                                  ※ご応募から内定までは3～4週間を予定しております<br/>
                                                                  ※面接日、入社日はご相談に応じます<br/>
                                                                  ※結果については合否に関わらずご連絡いたします<br/>
              </p>
          </div>

        </div>
      </div>
    </div>
  </div>
  </body>
</template>


<style>
@import "../../css/Portal_base_engineer.css";
</style>

<script>
export default {
  jsonld: {
    "@context": "http://schema.org",
    "@type": "JobPosting",
    "datePosted": "2022-04-19",
    "validThrough": "2030-03-31",
    "employmentType": "FULL_TIME",
    "title": "システムエンジニア",
    "description": "大森駅に本社があるIT企業です。<br><br>【仕事内容】<br>ITコンサルティング、クラウドサービス開発、デジタルオペレーション開発などの業務を担当していただきます。<br>基本的にはチームでの業務となり、単独で実施することはありません。<br>ネットワーク・サーバーの設計・構築をメインに、 チーム配属で業務に取り組んでいただきます。",
    "hiringOrganization": {
      "@type": "Organization",
      "name": "株式会社HES",
      "logo": "https://recruit.he-service.co.jp/static/img/recruit_logo.png"
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "postalCode": "140-0013",
        "streetAddress": "南大井6-16-16 鈴中ビル大森アネックス8階",
        "addressLocality": "品川区",
        "addressRegion": "東京都",
        "addressCountry": "JP",
      }
    },
    "baseSalary": {
      "@type": "MonetaryAmount",
      "currency": "JPY",
      "value": {
        "@type": "QuantitativeValue",
        "minValue": 5000000,
        "maxValue": 12000000,
        "unitText": "YEAR"
      }
    }
  },
  methods: {
    router_ApplicationForm(){
      const next = 'auth/ApplicationForm';
      this.$router.push({name:next}).catch(() => {});
    },
  }
}
</script>


